import { useState } from 'react';

import { useAuth } from '../../../context/useAuth';
import { useNavigateToPortalUrl } from '../../hooks/useNavigateToPortalUrl';
import { useNavigateToApps } from '../../hooks/useNavigateToApps';
import type { RedirectHashParams } from '../../../types/hashParams';

export function useRedirectToClient() {
  const { createPortalUrl } = useNavigateToPortalUrl();
  const { createAppUrl } = useNavigateToApps();

  const { user } = useAuth();

  const [redirectingToClient, setRedirectingToClient] = useState(false);

  const redirectToClient = (redirectUrl: string, token?: string) => {
    setRedirectingToClient(true);

    const hashParams: RedirectHashParams = {};

    if (token || user?.token) {
      hashParams['accessToken'] = token || user?.token;
    }

    /**
     * Here portal url will always have the callback in the URL.
     * So, we have to check if redirectURL includes callback or not. If yes go back to portal.
     * If not then we can assume that it's either payroll or r1 or book creation wizard.
     */
    const destinationURL = redirectUrl.includes('callback')
      ? createPortalUrl(redirectUrl, hashParams)
      : createAppUrl(redirectUrl, hashParams);

    window.location.replace(destinationURL);
  };

  return { redirectToClient, redirectingToClient };
}
